__turbopack_context__.v({
  "active": "index-module__cZHFhq__active",
  "footer": "index-module__cZHFhq__footer",
  "icon": "index-module__cZHFhq__icon",
  "label": "index-module__cZHFhq__label",
  "nav": "index-module__cZHFhq__nav",
  "navItem": "index-module__cZHFhq__navItem",
});
